import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
/**
 * @param {ErrorResponse} errorResponse
 *
 * @returns {null|string}
 */

export default (function (errorResponse) {
  var _ref = errorResponse.getData() || {},
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors;

  if (errors === null) {
    return null;
  }

  var firstErrorMessage = errors.find(function (error) {
    return isObject(error) && !isUndefined(error.message);
  });
  return isUndefined(firstErrorMessage) ? null : firstErrorMessage.message;
});